import { render, staticRenderFns } from "./RequisicaoInserir.vue?vue&type=template&id=d76bde9c"
import script from "./RequisicaoInserir.vue?vue&type=script&lang=js"
export * from "./RequisicaoInserir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports